import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=294f04b3&scoped=true"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"
import style0 from "./SSO.vue?vue&type=style&index=0&id=294f04b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f04b3",
  null
  
)

export default component.exports